import React, { useEffect, useState } from 'react'
import { makeAuthenticatedGETRequest, makeAuthenticatedPOSTRequest } from "../../services/serverHelper";
import { patronProfilePoints } from "../../services/apis";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import PatronNavbar from '../Patron_Navbar'
import PatronSidebar from '../PatronSidebar'
import { toast } from "react-toastify";
import './PatronInviteArtist.css'

const PatronInviteArtist = () => {
  const [selectedIds, setSelectedIds] = useState([])
  const [artistEmail, setArtistEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState(null)
  const {id} = useParams();

  const [opportunities, setOpportunities] = useState([]);
  
  const { accessToken } = useSelector((state) => state.auth);


const navigate = useNavigate();

  const fetchOpportunities = async () => {
      setLoading(true);
      try {
        const response = await makeAuthenticatedGETRequest(
          patronProfilePoints.UPLOAD_OPPOR_API,
          accessToken
        );
        console.log(response);
  
        if (response.status === "success") {
          let parseData = await response.data;
        //   const reversed = [...parseData].reverse();
          setOpportunities(response.data);
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        console.log(error);
        toast.error("something went wrong , please try again");
      }
      setLoading(false);
    };

  useEffect(() => {
    fetchOpportunities()
  }, [])

  const toggleSelect = (id) => {
    setSelectedIds(prev => {
    if (prev.includes(id)) {
      return prev.filter(item => item !== id); // remove
    }

    return [...prev, id]; // add
  });
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setMessage(null)
    // if (!artistEmail) {
    //   setMessage({ type: 'error', text: 'Please enter the artist email or ID.' })
    //   return
    // }
    if (selectedIds.size === 0) {
      setMessage({ type: 'error', text: 'Select at least one opportunity to invite for.' })
      return
    }

    setLoading(true)
    try {
      const response = await makeAuthenticatedPOSTRequest(
        `${patronProfilePoints.INVITE_ARTIST_API}/${id}`,
        {
          opportunityIds: selectedIds
        },
        accessToken
      )
      setMessage({ type: 'success', text: 'Invite sent successfully.' })
      setSelectedIds([])
      setArtistEmail('')
      

    } catch (err) {
      setMessage({ type: 'error', text: err.message || 'Failed to send invite.' })
    } finally {
      setLoading(false)
    }
  }

  return (
    <div>
      <PatronNavbar />
      <div className="dashboard-layout">
        <PatronSidebar />
        <div className='patron-artist-invite'>
            <div className="invite-header-section">
              <div className='patron-invite-overlay'>
                <h1 className="invite-header">ARTIST INVITATION</h1>
              </div>
            </div>
            <form onSubmit={handleSubmit} className="invite-form">

                <div className="form-group">
                    <label className="form-label">Select opportunities</label>
                    {opportunities.length === 0 && <div>No opportunities found.</div>}
                    <ul className="opp-list">
                        {opportunities.map((opp) => (
                        <li key={opp.id} className="opp-item">
                            <input
                            id={`opp-${opp.id}`}
                            type="checkbox"
                            checked={selectedIds.includes(opp.id)}
                            onChange={() => toggleSelect(opp.id)}
                            />
                            <label htmlFor={`opp-${opp.id}`} className="opp-label">
                            <strong>{opp.purpose}</strong> {opp.date ? `— ${opp.date}` : ''}
                            </label>
                        </li>
                        ))}
                    </ul>
                </div>

                <div className="form-group">
                    <button type="submit" disabled={loading} className="submit-btn">
                        {loading ? 'Sending…' : `Send Invite (${selectedIds.length})`}
                    </button>
                </div>

                {message && (
                <div className={message.type === 'error' ? 'message-error' : 'message-success'}>{message.text}</div>
                )}
            </form>
        </div>

      </div>
    </div>
  )
}

export default PatronInviteArtist